import Control from "../FieldEditor/FieldEditor";
import { useEditor } from "../EditorContext"


function VerticalLayout ({groupId, layout, formStructure}) {

  let rows = [];
  for (let i in layout.elements) {

    if (layout.elements[i].type == 'Control') {
      rows.push(
        <Control 
          control={layout.elements[i]}
          formStructure={formStructure}
          //removeElement={removeElement}
        />
      );
    }
    /*
    if (layout.elements[i].type == 'Label') {
      rows.push(
        <Label 
          label={layout.elements[i]}
          formStructure={formStructure}
          //removeElement={removeElement}
        />
      );
    }
    */
  }

  return (
    <>
      <h6>Вертикальный макет</h6>
      {rows}
    </>
  )
}

export default VerticalLayout